import { render, staticRenderFns } from "./TipCreate.vue?vue&type=template&id=e16c8850&"
import script from "./TipCreate.vue?vue&type=script&lang=js&"
export * from "./TipCreate.vue?vue&type=script&lang=js&"
import style0 from "./TipCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports